// Vendor JS
import Debug from 'debug';

// Custom JS
import Portfolios from '../common/portfolios';

/* eslint-disable no-unused-expressions */

/**
 * Fired on portfolio pages
 */
export default {
	init() {
		try {
			Debug(`cig:info:sage:route:portfolio`)(`init start`);

			// Run Portfolios class init method
			Portfolios.init();

		} catch (err) {
			Debug(`cig:error:sage:route:portfolio`)(`Portfolio Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:portfolio`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:portfolio`)(`Login Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},
};
